export default "__VITE_ASSET__jQdAebPy__"